import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import ModalComponent from '../../components/ModalComponent'
import Dropper from '../../components/Dropper'
import { DatePicker } from 'react-rainbow-components'
import { BsPlusSquare } from 'react-icons/bs'
import {
	create_campaign,
	update_campaign_status,
	get_all_campaigns,
	update_campaign,
} from '../../redux/actions/campaignActions'
import Loader from '../../components/Loader'
import {
	CAMPAIGN_CREATE_RESET,
	GET_ALL_CAMPAIGNS_RESET,
} from '../../redux/types'
import { comma } from '../../utils/helper'
import { DateTime } from 'luxon'
import { GrFormView, GrFormEdit } from 'react-icons/gr'

const DashboardCampaign = () => {
	const dispatch = useDispatch()

	const campaignCreate = useSelector((state) => state.campaignCreate)
	const { loading, campaign } = campaignCreate

	const campaignUpdate = useSelector((state) => state.campaignUpdate)
	const { loading: loadingUpdate, success: successUpdate } = campaignUpdate

	const campaignUpdateStatus = useSelector(
		(state) => state.campaignUpdateStatus
	)
	const { loading: loadingStatusUpdate, success: successStatusUpdate } =
		campaignUpdateStatus

	const getAllCampaigns = useSelector((state) => state.getAllCampaigns)
	const { loading: loadingGet, campaigns } = getAllCampaigns

	const [openModal, setOpenModal] = useState(false)

	const [name, setName] = useState('')
	const [amount, setAmount] = useState('')
	const [currency, setCurrency] = useState('naira')
	const [banner, setBanner] = useState({})
	const [startDate, setStartDate] = useState('')
	const [intro, setIntro] = useState('')
	const [endDate, setEndDate] = useState('')
	const [details, setDetails] = useState('')
	const [id, setId] = useState(null)
	const [ImageArray, setImageArray] = useState([])
	const [message, setMessage] = useState(null)
	const [selected, setSelected] = useState(null)

	const [uploadedImage, setUploadedImage] = useState('')
	const [uploading, setUploading] = useState(false)
	const [imageFile, setImageFile] = useState('')

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	function onStartDateChange(startDate) {
		setStartDate(startDate)
	}

	function onEndDateChange(endDate) {
		setEndDate(endDate)
	}

	const getBase64 = (file) => {
		return new Promise((resolve) => {
			let baseURL = ''
			let reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => {
				// Make a fileInfo Object
				baseURL = reader.result
				resolve(baseURL)
			}
		})
	}

	const _setFile = (file) => {
		console.log(file)
		getBase64(file)
			.then((result) => {
				file['base64'] = result
				console.log('File Is', file)
				let split = file.base64.split(',')
				setImageFile(split[1])
			})
			.catch((err) => {
				console.log(err)
			})

		setImageArray([
			{
				file: file,
				cover: URL.createObjectURL(file),
				key: ImageArray.length,
			},
		])

		uploadFileHandler()
	}

	const uploadFileHandler = () => {
		const formData = new FormData()
		formData.append('file', ImageArray[0].file)
		formData.append('image', ImageArray[0].file)
		formData.append('upload_preset', 'feemfundy')
		formData.append('cloud_name', 'neutrinookoye')

		setUploading(true)

		fetch('https://api.cloudinary.com/v1_1/neutrinookoye/image/upload', {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setUploading(false)
				// setMainImage(null)
				setUploadedImage(data.url)
				setImageFile('')
			})
			.catch((err) => {
				console.log(err)
				setUploading(false)
				// setMainImage(null)
				setImageFile('')
			})
	}

	const statusUpdateHandler = (e) => {
		e.preventDefault()
		if (window.confirm('Are you sure?')) {
			dispatch(update_campaign_status(name))

			setTimeout(() => {
				setOpenModal(false)
			}, 1000)
		}
	}

	const editHandler = (e, data) => {
		e.preventDefault()
		setId(data._id)
		setName(data.name)
		setAmount(data.amount)
		setCurrency(data.currency)
		setStartDate(data.startDate)
		setEndDate(data.endDate)
		setIntro(data.intro)
		setDetails(data.details)
		setOpenModal(true)
	}

	const submitHandler = (e) => {
		e.preventDefault()

		if (id === null) {
			if (uploadedImage !== '') {
				if (
					ImageArray !== [] &&
					name !== '' &&
					amount !== '' &&
					currency !== '' &&
					startDate !== '' &&
					intro !== '' &&
					endDate !== '' &&
					details !== ''
				) {
					let data = {
						name,
						amount,
						currency,
						startDate,
						intro,
						endDate,
						details,
						banner: uploadedImage,
					}

					dispatch(create_campaign(data))

					setTimeout(() => {
						setName('')
						setAmount('')
						setCurrency('naira')
						setStartDate('')
						setIntro('')
						setEndDate('')
						setDetails('')
						setMessage(null)
						setImageArray([])
						setOpenModal(false)
					}, 1000)
				} else {
					setMessage('Please fill in all details')
				}
			} else {
				setMessage("Couldn't upload image")
			}
		} else {
			let data = {
				name,
				amount,
				currency,
				startDate,
				intro,
				endDate,
				status: selected,
				details,
				banner: uploadedImage,
			}

			dispatch(update_campaign(name, data))
			setTimeout(() => {
				setOpenModal(false)
			}, 1000)
		}
	}

	const categoryHead = [
		'S/N',
		'Name',
		'Amount',
		'Closing Date',
		'Status',
		'Public',
		'View',
		'Edit',
	]
	let i = 0

	useEffect(() => {
		dispatch(get_all_campaigns())

		return () => {
			dispatch({ type: CAMPAIGN_CREATE_RESET })
			dispatch({ type: GET_ALL_CAMPAIGNS_RESET })
		}
	}, [dispatch, campaign, successUpdate, successStatusUpdate])

	return (
		<section className='user_dashboard'>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 text-right'>
						<Link
							to='#'
							onClick={(e) => {
								e.preventDefault()
								setOpenModal(true)
								setId(null)
								setName('')
								setStartDate('')
								setBanner('')
								setIntro('')
								setCurrency('')
								setAmount('')
								setEndDate('')
								setDetails('')
							}}
							className='btn btn-danger text-white'
						>
							Create Campaign
						</Link>
					</div>

					<div className='col-12'>
						{loadingGet ? (
							<Loader />
						) : (
							<>
								{campaigns && campaigns.length > 0 ? (
									<div className='mt-5 table-responsive shadow-sm'>
										<table className='table table-bordered table-striped'>
											<thead className=''>
												<tr>
													{categoryHead.map((cate, i) => (
														<th key={i}>{cate}</th>
													))}
												</tr>
											</thead>
											<tbody>
												{campaigns.map((l, i) => (
													<tr key={l._id}>
														<td>{++i}</td>
														<td>{l.name}</td>
														<td>
															{l.currency === 'naira' ? (
																<span>&#8358;</span>
															) : (
																<span>$</span>
															)}
															{comma(l.amount)}
														</td>
														<td>
															{DateTime.fromISO(l.endDate).toLocaleString(
																DateTime.DATETIME_MED
															)}{' '}
														</td>
														<td>{l.status}</td>
														<td>{l.active ? 'True' : 'False'}</td>
														<td>
															<Link to={`/campaign/${l.name}`} target='_blank'>
																<GrFormView size={20} />
															</Link>
														</td>
														<td>
															<Link to='#' onClick={(e) => editHandler(e, l)}>
																<GrFormEdit size={20} />
															</Link>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								) : (
									<div className='card mt-3'>
										<div className='card-body'>
											<p className='nothing'>No Campaigns found</p>
										</div>
									</div>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<ModalComponent
				open={openModal}
				toggle={toggleModal}
				size='lg'
				title={` ${id ? 'Edit' : 'Add'} Campaign`}
			>
				<div className='login_form'>
					<form className='tagForm' onSubmit={submitHandler}>
						<label className='label'>Name</label>
						<input
							type='text'
							value={name}
							className='form-control mb-3'
							onChange={(e) => setName(e.target.value)}
							disabled={id ? true : false}
						/>
						<label className='label'>Amount</label>
						<input
							type='text'
							value={amount}
							className='form-control mb-3'
							onChange={(e) => setAmount(e.target.value)}
						/>
						<label className='label'>Currency</label>
						<select
							className='form-select mb-3'
							onChange={(e) => setCurrency(e.target.value)}
							aria-label='Default select example'
						>
							<option value=''>-- select currency --</option>
							<option value='naira'>Naira</option>
							<option value='dollar'> Dollar </option>
						</select>
						<label className='label'>Start Date</label>
						<DatePicker
							id='datePicker-1'
							value={startDate}
							onChange={onStartDateChange}
							label=''
							formatStyle='large'
							className='mb-3'
						/>
						<label className='label'>End Date</label>
						<DatePicker
							id='datePicker-1'
							value={endDate}
							onChange={onEndDateChange}
							label=''
							formatStyle='large'
							className='mb-3'
						/>
						<label htmlFor=''>Short Info</label>
						<textarea
							// value={info}
							onChange={(e) => setIntro(e.target.value)}
							cols='30'
							className='form-control'
							rows='3'
						></textarea>
						<label htmlFor=''>Details</label>
						<textarea
							// value={details}
							onChange={(e) => setDetails(e.target.value)}
							cols='30'
							className='form-control'
							rows='10'
						></textarea>
						<label htmlFor=''>Banner Image</label>
						<Dropper
							setFile={(file) => _setFile(file)}
							upload={() => uploadFileHandler()}
							caption={
								<span
									className='d-flex align-items-center'
									style={{ height: '156px', cursor: 'pointer' }}
								>
									<BsPlusSquare size={50} />
								</span>
							}
							imageArray={ImageArray}
							accept='image/*'
						/>
						{uploading ? <i className='fas fa-spinner fa-spin'></i> : null}
						<input
							type='text'
							value={uploadedImage}
							onChange={(e) => setUploadedImage(e.target.value)}
							className='site-form mb-3 d-none'
						/>
						{id && (
							<>
								<label> Status </label>
								<select
									value={selected}
									onChange={(e) => setSelected(e.target.value)}
									className='form-select'
								>
									<option value=''> -- select status -- </option>
									<option value='Accepting Submissions'>
										{' '}
										Accepting Submissions{' '}
									</option>
									<option value='Submission Closed'> Submission Closed </option>
									<option value='Funds Disbursed'> Funds Disbursed </option>
								</select>
							</>
						)}

						<div className='d-flex justify-content-between mt-4'>
							<div>
								<button
									disabled={loading ? true : uploading ? true : false}
									className='btn btn-secondary'
								>
									{loading || loadingUpdate ? (
										<i className='fas fa-spinner fa-spin'></i>
									) : id ? (
										'Update'
									) : (
										'Create'
									)}
								</button>
								<p style={{ fontSize: '12px', color: 'red' }}> {message} </p>
							</div>
							{id && (
								<div>
									<button
										className='btn btn-danger'
										onClick={statusUpdateHandler}
										disabled={loadingStatusUpdate ? true : false}
									>
										Update Status
									</button>
								</div>
							)}
						</div>
					</form>
				</div>
			</ModalComponent>
		</section>
	)
}

export default DashboardCampaign
